import React from "react";
import { Button, Dropdown } from "antd";
import { MoreOutlined } from "@ant-design/icons";

const ActionsDropdown = ({ row, handleAction, isActive }) => {
  const items = [
    isActive
      ? { key: "deactive", label: "Deactivate" }
      : { key: "active", label: "Activate" },
    { key: "edit", label: "Edit" },
    { key: "delete", label: "Delete", danger: true },
  ];

  return (
    <Dropdown
      trigger={["click"]}
      placement="bottomRight"
      menu={{
        items,
        onClick: ({ key }) => handleAction(key, row),
      }}
    >
      <Button type="text" icon={<MoreOutlined style={{ fontSize: 18 }} />} />
    </Dropdown>
  );
};

export default ActionsDropdown;
